export default __webpack_public_path__ + "static/1.1_FR-f3ab983e00f1ee17ebc627cdc9083f16.png";